import axios from "axios";
import Papa from "papaparse";
//todo sqft-react
// import mainclass from "./classes/main";
import config from "./components/canvas/store/sqftConfig";
import {getParamFromUrl} from "./helpers/sqftHelper";

export default new function() {
  this.translatesPath = "./translates/translates_sqft_v1.csv";
  this.locale = getParamFromUrl("language") || "en-US";
  this.translates = {};

  this.replaceHtml = (locale, translates = {}) => {
    this.updateButtonAddToQuote();
    this.locale = locale || getParamFromUrl("language") || "en-US";
    const allElements = [].slice.call(document.querySelectorAll("[data-text]"));
    // allElements.forEach((element) => {
    //   const key = element.dataset.text;
    //   element.innerText = this.translate(key);
    // });
    // allElements.forEach((element) => {
    //   const key = element.dataset.text;
    //   const existingTranslate = this.translates[this.locale][key];
    //   if (existingTranslate) {
    //     element.innerText = existingTranslate
    //   } else {
    //     console.info("missing translate", key);
    //   }
    // });
    if (Object.keys(translates).length) {
      Object.keys(translates).forEach(loc => {
        if (!this.translates[loc]) {
          this.translates[loc] = {};
        }
        this.translates[loc] = Object.assign({}, this.translates[loc], translates[loc])
      })
    }
    allElements.forEach((element) => {
      const key = element.dataset.text;
      let translated = this.translate(key);
      if(key !== translated) {
        element.innerText = translated;
      } else {
        // console.info("missing translate", key);
      }
    });
  };

  this.getTranslationColumn = (locale) => {
    const fabricatorData = config.fabricatorData;
    if (fabricatorData && locale === "en-US") {
      if (fabricatorData.isLowes) {
        return "en-US(Lowes)"
      } else if (fabricatorData.isGraniteTransformationUK) {
        return "en-GT UK Custom"
      } else if (fabricatorData.isCaesarStone) {
        return "en-US(Caesarstone)"
      } else if (fabricatorData.isLixil) {
        return "en-US(Lixil)"
      }
    }

    return locale
  };

  const loadTranslates = (response) => {
    // handle success
    let translates = {};
    Papa.parse(response.data, {
      complete: (results) => {
        // console.log("Finished:", results.data);
        results.data[0].forEach((locale) => {
          if (locale !== "key") {
            translates[locale] = {};  // simple create an empty objects for each locale
          }
        });
        results.data.forEach((translatesArray, translatesArrayIndex) => { // vertical forEach
          if (translatesArrayIndex) { // not 0 (the first key line)
            const key = translatesArray[0]; // key, for ex. login.email
            translatesArray.forEach((translateValue, translateValueIndex) => { // horizontal forEach
              if (translateValueIndex) { // skip first key
                const locale = results.data[0][translateValueIndex]; // get first line and locale index
                if (translateValue) {
                  translates[locale][key] = translateValue
                }
              }
            });
          }
        });
      }
    });
    this.translates = translates;
    console.log("translates", this.translates);
    this.replaceHtml();
    //mainclass.init(); //todo sqft-react
  };

  this.init = () => {
    // if (document.kvConfig.kioskMode) {
    //   KioskApp.PostMessage({type: 'getTranslates'}).then(res => this.loadTranslates({data: res})).catch(console.log);
    // } else {
    axios.get(this.translatesPath)
      .then(loadTranslates)
      .catch(console.error);
    // }
  };

  this.translate = (key, translationMissingValue = null) => {
    let translationColumn = this.getTranslationColumn(this.locale);
    let translated = this.translates[translationColumn][key];
    if (translated === undefined) {
      //console.info("missing translate", key);
      return translationMissingValue ? translationMissingValue : key;
    }

    return translated;
  };

  this.translateEdgeToFrench = (edgeSharedFeatureName, edgeName) => {
    return this.translate(
      'transDoc.customDisplayName_FR.' + edgeSharedFeatureName.trim(), edgeName
    );
  };

  this.updateButtonAddToQuote = () => {
    let isSqftVisited = getParamFromUrl("sqftVisited");
    const buttonsAddToQuote = [].slice.call(document.querySelectorAll('[data-text="sqft.footer.buttonAddToQuote"]'));
    buttonsAddToQuote.forEach((element) => {
      element.dataset.text = isSqftVisited === "true" ? 'sqft.footer.buttonUpdateCartButton' : 'sqft.footer.buttonAddToQuote'
    });
  }
};
